import React, { useEffect, useState } from 'react'
import ClientLayout from './ClientLayout'
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { useFormik } from 'formik';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import { Modal } from 'antd';
import ViewEquipmentsClient from './EquipmentView';
import EquipmentmobCard from '../../../Mobile/ClientManage/ClientMoblie/MobileEquipmentIndex';



function Equipments() {

    const { clientViewId } = useParams();
    const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state
    
   
     const location = useLocation();
      const currentPage= location.state?.currentPage
      const searchQuery= location.state?.searchQuery
      const state = location.state;

          const [page, setPage] = useState(currentPage||1)
          const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
    const [filter, setFilter] = useState(false);
        const [showFilterDialog, setShowFilterDialog] = useState(false);
        const {value:brand} = useFetchMDIndex
        (`/dropdown/dropdown-details/`,'brand_equipments',showFilterDialog)
        const {value:unit} = useFetchMDIndex
        (`/dropdown/dropdown-details/`,'unit_equipments',showFilterDialog)
              const [filterProps, setFilterProps] = useState({
                   
                    brand:"",
                    
                  });
                  const [params, setParams] = useState({
                    page: page,
                    per_page: pageCount,
                    search:searchQuery||"",
                   
                    brand:"",
                    
                  });
                  const clearFilter = ()=> {
                    setParams({...params,
                    brand:"",
                    
                  })
                 
                  formik.values.brand=""
                 
                
                
                      setFilter(false)
                  }
                
                  const formik = useFormik({
                    enableReinitialize: true,
                    initialValues: filterProps,
                    validateOnChange: false,
                    validateOnBlur: false,
                    validationSchema: yup.object({
                      // email: yup.string().required('Email is required!'),
                    }),
                    onSubmit: async (value, { resetForm }) => {
                      console.log("ffff",value);
                      setParams({...params,brand:value.brand})
                      closeFilterDialog();
                      setFilter(true)
                      setFilterProps({
                       
                        brand:"",
                      
                      });
                    }
                  })

                  const closeFilterDialog = () => {
                    setShowFilterDialog(false);
                  };

                  const { data,getData,dataLoading } = UseGetDataSearch( `/contract/client-equipments/${clientViewId}`,params);
                  console.log(data,"contractcli");

                  // const openViewModal = () => {
                  //   setIsViewModalOpen(true);
                   
                  // };
                  const [viewModalData, setViewModalData] = useState(null);

                  const openViewModal = (data) => {
                    setViewModalData(data);
                    setIsViewModalOpen(true);
                  };

                  const [screenSize, setScreenSize] = useState({
                              width: window.innerWidth,
                            });
                          
                            useEffect(() => {
                              const handleResize = () => {
                                setScreenSize({
                                  width: window.innerWidth,
                                });
                              };
                          
                              window.addEventListener("resize", handleResize);
                          
                              return () => {
                                window.removeEventListener("resize", handleResize);
                              };
                            }, []);
                  
  return (
    <>
    <ClientLayout 
    // setFilterOpen={setShowFilterDialog}
    //      ClearFilter={clearFilter}
    //      newfilter={true}
    //      isFilter={filter}
         BackAccess={GetAccess("client_management_module")}
   
   >

{
  screenSize.width < "768" ?(<>
  <div className=' w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <EquipmentmobCard
  data={data}
  // // total={totalCount}
  // pageIndex={page}
  // setPageIndex={setPage}
  // dataCount={pageCount}
  // setDataCount={setPageCount}
  // officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
     <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
     <table className="min-w-full text-xs text-left">
       <thead>
         <tr className="text-black font-semibold  border-b border-gray-300">
           <th className="px-4 py-2 w-[10%]">Ref</th>
           <th className="px-4 py-2 w-[30%]">Equipment</th>
           <th className="px-4 py-2 w-[20%]">Unit</th>
           {/* <th className="px-4 py-2 w-[17.4%]">Brand</th> */}
           <th className="px-4 py-2 w-[20%]">Quantity</th>

           {/* <th className="px-4 py-2 w-[17.4%]">Model</th> */}
           {/* <th className="px-4 py-2">Quantity</th> */}
           <th className="px-4 py-2 w-[5%]">Action</th>
         </tr>
       </thead>
       <tbody>
         {data.map((item,i) => (
           <tr key={item.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
             <td className="px-4 py-2 w-[10%]">
             <Link
              // onClick={openViewModal}
              onClick={() => openViewModal(item)}
              >
              {item.refNumber}
</Link>
              
              </td>
             <td className="px-4 py-2 w-[30%]">
             <Link
              // onClick={openViewModal}
              onClick={() => openViewModal(item)}
              >
              {item.name || "-"}
</Link>
              
              </td>
             <td className="px-4 py-2 w-[20%]">{item.unit || "-"}</td>
             {/* <td className="px-4 py-2 w-[17.4%]">{item.brand || "-"}</td> */}
             <td className="px-4 py-2 w-[20%]">{item.quantity || "-"}</td>

             {/* <td className="px-4 py-2 w-[17.4%]">{item.model || "-"}</td> */}
             {/* <td className="px-4 py-2">{item.quantity}</td> */}
             <td className="px-4 py-2 text-gray-500 w-[5%]" >
               <Link
              // onClick={openViewModal}
              onClick={() => openViewModal(item)}
              >
                               <ViewIcon color="#048178" />

</Link>
</td>
           </tr>
         ))}
       </tbody>
     </table>
   </div>

   </>)}
   </ClientLayout>

   {isViewModalOpen && (       
        <Modal
        open={isViewModalOpen}
        onCancel={()=>setIsViewModalOpen(false)}
        title={"View Equipment"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        <ViewEquipmentsClient data={viewModalData} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
   </Modal>
      )}


   {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
              {/* <FormikSelectTwo
                type="text"
                label="Unit"
                placeholder="Choose unit"
                Options={unit}
                formik={formik}
                name="unit"
                width="w-full"
                 /> */}
               <FormikSelectTwo
                type="text"
                label="Brand"
                placeholder="Choose Brand"
                Options={brand}
                formik={formik}
                name="brand"
                width="w-full"
                 />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
     </>
  )
}

export default Equipments
